// extracted by mini-css-extract-plugin
module.exports = {"text":"dist-es__Text__text"};